import * as React from "react";
import { formatDate } from 'src/util/Date.helper';
import { IExpensePayment } from 'src/services/interfaces/Expense/IExpensePayment';

interface IExpensePaymentInfoProps {
  expensePayment: IExpensePayment;
}

export const ExpensePaymentInfo: React.FC<IExpensePaymentInfoProps> = ({ expensePayment }) => (
  <div className="region-container client-info">
    <span className="subtitle">Informações de Pagamento</span>
    <div>
      <div className="row">
        <span className="left description">Data agendada para o pagamento:</span>
        {expensePayment?.schedulePaymentDate &&
          <span className="right description">{formatDate(expensePayment.schedulePaymentDate)}</span>
        }
      </div>
    </div>
  </div>
);


// WEBPACK FOOTER //
// ./src/components/common/ExpenseList/Details/ExpensePaymentInfo/ExpensePaymentInfo.tsx